import React from "react"

export type RadioGroupContextType<T = any> = {
  name?: string
  value: T
  onChange: (changeEvent: React.ChangeEvent<HTMLInputElement>) => void
}

export const RadioGroupContext = React.createContext<RadioGroupContextType>({
  value: null,
  onChange: () => undefined,
})
